import { put, call, takeLatest } from "redux-saga/effects";
import {
    FETCH_SUPPORT_DASHBOARD,
    fetchSupportDashboardSuccess,
    fetchSupportDashboardFailure,
} from "../actions/fetchSupportDashboardActions";
import { BASE_DATA_COTTAGE_BACKEND_URL } from "../constant";
import { toast } from "react-toastify";

const fetchSupportDashboardAPI = async (resourceId) => {
    const url = `${BASE_DATA_COTTAGE_BACKEND_URL}/data_syncs/reports?resource_id=${resourceId}`;
    const response = await fetch(url);
    if (!response.ok) {
        toast.error("Error fetching support dashboard", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        throw new Error("Error fetching support dashboard");
    }
    const data = await response.json();
    return data;
};

function* fetchSupportDashboardWorker(action) {
    try {
        const data = yield call(fetchSupportDashboardAPI, action.payload.resourceId);
        yield put(fetchSupportDashboardSuccess(data));
    } catch (error) {
        yield put(fetchSupportDashboardFailure(error.message));
    }
}

function* fetchSupportDashboardWatcher() {
    yield takeLatest(FETCH_SUPPORT_DASHBOARD, fetchSupportDashboardWorker);
}

export default fetchSupportDashboardWatcher;
